import React from "react";
import { Sparkles } from "lucide-react";
import { COMING_SOON_FEATURES } from "@/lib/comingSoon";
import ComingSoonBadge from "@/components/ComingSoonBadge";

// "Coming Soon to Postmoro" section — used on the homepage between the
// primary product sections and pricing, and reused inside the authenticated
// app as a roadmap area. No card in this section triggers any API,
// generates any content, or performs any user-visible action.
export default function ComingSoonSection({
  eyebrow = "Roadmap",
  title = "Coming Soon to Postmoro",
  subtitle = "Postmoro is becoming more than a social media scheduler. We're building more ways for AI to help run your business's marketing from one place.",
  className = "",
}) {
  return (
    <section
      id="coming-soon"
      className={
        "max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-10 py-14 " + className
      }
      data-testid="coming-soon-section"
      aria-label="Upcoming Postmoro features"
    >
      <p className="eyebrow text-[color:var(--brand-primary)]">{eyebrow}</p>
      <h2 className="mt-2 font-display text-2xl sm:text-3xl font-semibold tracking-tight">
        {title}
      </h2>
      <p className="mt-4 text-[color:var(--text-2)] leading-relaxed max-w-3xl">
        {subtitle}
      </p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {COMING_SOON_FEATURES.map((f) => {
          const Icon = f.icon || Sparkles;
          return (
            <div
              key={f.id}
              className="rounded-2xl border border-[color:var(--border-subtle)] bg-[color:var(--surface-1)] p-5 flex flex-col"
              data-testid={`coming-soon-card-${f.id}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="h-9 w-9 rounded-lg flex items-center justify-center bg-[color:rgba(27,168,159,0.10)] text-[color:var(--brand-primary)]">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <ComingSoonBadge
                  testId={`coming-soon-badge-${f.id}`}
                />
              </div>
              <div className="mt-3 font-display text-base font-semibold text-[color:var(--text-1)]">
                {f.name}
              </div>
              <p className="mt-1.5 text-sm text-[color:var(--text-2)] leading-relaxed flex-1">
                {f.short}
              </p>
              <div
                className="mt-3 text-[11px] uppercase tracking-[0.14em] text-[color:var(--text-3)]"
                data-testid={`coming-soon-plans-${f.id}`}
              >
                Plan: {f.planLabel}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
